import { createContext, useContext } from 'react'

interface ProjectContextValue {
  projectId: string
}

const ProjectContext = createContext<ProjectContextValue | null>(null)

export function ProjectProvider({
  projectId,
  children,
}: {
  projectId: string
  children: React.ReactNode
}) {
  return (
    <ProjectContext.Provider value={{ projectId }}>
      {children}
    </ProjectContext.Provider>
  )
}

/**
 * Returns the current project ID from the nearest ProjectProvider.
 * Falls back to the provided fallbackId if no provider is found.
 */
export function useCurrentProjectId(fallbackId?: string): string | undefined {
  const ctx = useContext(ProjectContext)
  return ctx?.projectId ?? fallbackId
}
